import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  PAGE_PATH,
  REMOTE_COMMAND,
  REMOTE_MEMBER_STATUS,
} from '../../lib/constants';
import AppButton from '../../styles/common/AppButton';
import Call from '../Icons/Call';
import { getCallingRoomMembers, getCallingRooms } from '../../actions/api/apis';
import ColorSF2 from '../../styles/common/ColorSF2';

const Dialog = styled.div`
  overflow-y: auto;
  width: 314px;
  max-height: 520px;
  display: flex;
  flex-direction: column;
  @media (max-height: 530px) {
    max-height: 310px;
  }
`;

const RoomWrapper = styled.div`
  height: 65px;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  border: 1px solid ${ColorSF2.mediumGray};
`;
const RoomInfo = styled.div`
  width: 220px;
  height: 36px;
  font-size: 12px;
  color: ${ColorSF2.black};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
const FavoriteName = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;

/**
 * 通話中ルームの一覧を表示するダイアログのコンポーネント
 */
class CallingRoomsDialog extends Component {
  constructor(props) {
    super(props);
    this.setTimer();
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  getCallingRoomMembersInfo() {
    const { callingRooms, apiToken, dispatch } = this.props;
    const appRoomIds = callingRooms.map(({ appRoomId }) => appRoomId);
    dispatch(getCallingRooms(apiToken));
    dispatch(getCallingRoomMembers(apiToken, appRoomIds));
  }

  setTimer() {
    const { dispatch, apiToken } = this.props;
    this.closeTimer();
    if (dispatch && apiToken) {
      this.getCallingRoomMembersInfo({ dispatch, apiToken });
      this.mainTimer = setInterval(
        () => this.getCallingRoomMembersInfo({ dispatch, apiToken }),
        10000,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { callingRooms, callingRoomsMembers, userInfo, onClose } = this.props;
    return (
      <Dialog role="presentation" onClick={e => e.stopPropagation()}>
        {callingRoomsMembers.map(({ appRoomId, roomMembers }, idx) => {
          const linkTo = `${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.answer}?appRoomId=${appRoomId}`;
          const membersName =
            (roomMembers && roomMembers.map(({ name }) => name).join(', ')) ||
            '';
          const joinDisabled =
            !roomMembers ||
            roomMembers.some(
              member =>
                member.operatorId === userInfo.operatorId &&
                (member.status === REMOTE_MEMBER_STATUS.joined ||
                  member.status === REMOTE_MEMBER_STATUS.joining),
            );
          return (
            <RoomWrapper key={`${idx + 1}`}>
              <RoomInfo>
                {(() => {
                  const foundRoom = callingRooms.find(
                    room => room?.appRoomId === appRoomId,
                  );
                  return foundRoom?.favoriteName ? (
                    <FavoriteName>{foundRoom.favoriteName}</FavoriteName>
                  ) : (
                    <div>{membersName}</div>
                  );
                })()}
              </RoomInfo>
              {(joinDisabled && (
                <AppButton disabled small>
                  <Call color="white" width="20px" />
                  <FormattedMessage id="callingRoomsDialog.button.join" />
                </AppButton>
              )) || (
                <Link to={linkTo} target="_blank" onClick={onClose}>
                  <AppButton small>
                    <Call color="white" width="20px" />
                    <FormattedMessage id="callingRoomsDialog.button.join" />
                  </AppButton>
                </Link>
              )}
            </RoomWrapper>
          );
        })}
      </Dialog>
    );
  }
}

CallingRoomsDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  apiToken: PropTypes.string.isRequired,
  userInfo: PropTypes.object.isRequired,
  callingRoomsMembers: PropTypes.array.isRequired,
  callingRooms: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CallingRoomsDialog;
